import { Component, HostListener, Input, OnInit } from '@angular/core';

import { WindowRef } from '@planone/shared/util-browser-api';

@Component({
  selector: 'planone-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent implements OnInit {
  @Input() showMobileBottomBar: boolean | undefined | null;

  scrollTopVisible = false;

  constructor(private window: WindowRef) {}

  ngOnInit(): void {
    this.scrollTopVisible = this.window.nativeWindow.scrollY > 0;
  }

  scrollTop(): void {
    this.window.nativeWindow.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  @HostListener('window:scroll')
  track() {
    this.scrollTopVisible = window.scrollY > 0;
  }
}
